import { render, staticRenderFns } from "./surf.vue?vue&type=template&id=10436a01"
import script from "./surf.vue?vue&type=script&lang=js"
export * from "./surf.vue?vue&type=script&lang=js"
import style0 from "./surf.vue?vue&type=style&index=0&id=10436a01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports